// After a deploy, an open tab still runs the old build; its lazy pages point at chunk files the new build
// replaced, so navigating throws "Loading chunk N failed". When that happens we reload once to pick up the new
// build (a session flag stops loops), instead of showing a broken page.
import React from "react";

const KEY = "fable_chunk_reload_at";
const isChunkError = (err) => /Loading (CSS )?chunk [\w-]+ failed|ChunkLoadError|dynamically imported module/i.test(String((err && (err.message || err.name)) || err));

function reloadOnce() {
  try {
    const last = Number(sessionStorage.getItem(KEY) || 0);
    if (Date.now() - last < 30000) return false;
    sessionStorage.setItem(KEY, String(Date.now()));
  } catch (e) { /* storage blocked: still reload once */ }
  window.location.reload();
  return true;
}

const originalLazy = React.lazy;
React.lazy = (factory) => originalLazy(() => factory().catch((err) => {
  if (isChunkError(err) && reloadOnce()) return new Promise(() => {});
  throw err;
}));

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => { if (isChunkError(e.reason)) reloadOnce(); });
  window.addEventListener("error", (e) => { if (isChunkError(e.error || e.message)) reloadOnce(); });
}
